import React, { useState } from 'react'
import { connect } from 'react-redux';
import serialize from 'form-serialize';
import uuid from 'uuid';
import { I18n, Translate } from 'react-redux-i18n';
import scrollToElem from 'helpers/smooth-scroll-elem';
import firebase, { signInAnonymously } from 'firebase-with-auth';
import ViewContainer from 'components/ViewContainer';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Hero from 'components/Hero';
import Form from './form';
import './bussiness-cooperation.scss';

const STAGE_FORM = 'form';
const STAGE_COMPLETE = 'complete';

function BusinessCooperation() {
    const [stage, setStage] = useState(STAGE_FORM);
    const briefMessage = ((() => {
        switch (stage) {
        case STAGE_FORM:
            return 'business-cooperation.brief-describe';
        case STAGE_COMPLETE:
            return 'business-cooperation.feedback-message';
        default:
            return '';
        }
    })());

    async function handleSubmit(e) {
        e.preventDefault();
        let formData = serialize(e.currentTarget, { hash: true });
        const xss = (await import('xss')).default;
        formData = Object.entries(formData).reduce((accu, [key, value]) => {
            accu[key] = xss(value.trim());
            return accu;
        }, Object.create(null));
        try {
            await signInAnonymously;
            const database = firebase.firestore();
            const docRef = database.doc(`businessmen/${ uuid() }`);
            await docRef.set({
                updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
                ...formData
            });
            setStage(STAGE_COMPLETE);
            scrollToElem(document.body);
        } catch (error) {
            console.error(error);
            alert(I18n.t('general-error-message'));
        }
    }

    return (
        <ViewContainer>
            <Header show sticky/>
            <Hero langkey="business-cooperation.business-inquiry" />
            <section className="bussiness-cooperation">
                <Translate
                    className="brief-describe"
                    value={ briefMessage }
                    tag="h5"
                />
                { stage === STAGE_FORM && (
                    <Form handleSubmit={ handleSubmit } />
                ) }
            </section>
            <Footer />
        </ViewContainer>
    );
}

export default connect(state => ({ i18n: state.i18n }))(BusinessCooperation);
